import { render, staticRenderFns } from "./SincerityDetail.vue?vue&type=template&id=5c18eb7e&scoped=true&"
import script from "./SincerityDetail.vue?vue&type=script&lang=js&"
export * from "./SincerityDetail.vue?vue&type=script&lang=js&"
import style0 from "./SincerityDetail.vue?vue&type=style&index=0&id=5c18eb7e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c18eb7e",
  null
  
)

export default component.exports